import request from '@/api'

export async function getDetectAuth(data) {
  return request({
    url: `/capi/web-service/facial/record/getDetectAuth`,
    method: 'post',
    data
  })
}

export async function getResults(data) {
  return request({
    url: `/capi/web-service/facial/record/getResults`,
    method: 'post',
    data
  })
}
